import React from "react";
import {fbProjectService} from "../jwt/_services/firebase/fbProjectService";

export const fbProjectProvider = {
    getOptions,
    getItem,
};

async function getOptions(){
    try {
        const result = await fbProjectService.search(0, 1000, {});

        return result.data.map((itemData) => {
            const { id, name } = itemData
            return (
                {
                    id: id,
                    value: name,
                    label: <div><label>{name}</label></div>
                }
            )
        });
    } catch (error) {
       console.log(error.message)
    }
}

async function getItem(id){
    try {
        const item = await fbProjectService.getItem(id);
        return (
            {
                id: item.id,
                value: item.name,
                label: <div><label>{item.name}</label></div>}
        );
    } catch (error) {
        console.log(error.message)
    }
}